import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    PatientSkillAcqActiveProgramListActionTypes, 
    GET_PATIENT_SKILL_ACQ_ACTIVE_PROGRAMS_LIST_API,
} from '../constants/ApiConstants';

import { createSearchUrlForCustomAPI } from '../../../../../../../../../actions/utilAction';

export const PatientSkillAcqActiveProgramList = (searchObj, patientId, ProgramIds) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(PatientSkillAcqActiveProgramListActionTypes.get_patientSkillAcqActiveProgramList.REQUEST));
        fetch(`${GET_PATIENT_SKILL_ACQ_ACTIVE_PROGRAMS_LIST_API}${query_params}&patientId=${patientId}&ProgramIds=${ProgramIds}&includeProgramsForSkillAquisitionOnly=false`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(PatientSkillAcqActiveProgramListActionTypes.get_patientSkillAcqActiveProgramList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(PatientSkillAcqActiveProgramListActionTypes.get_patientSkillAcqActiveProgramList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientSkillAcqActiveProgramList', error);
            });
    };
};

export const SetUUID = (uuid) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(PatientSkillAcqActiveProgramListActionTypes.set_uuid.SUCCESS, uuid));
    }
}

export const OpenTargetCheck = (value) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(PatientSkillAcqActiveProgramListActionTypes.set_openTarget.SUCCESS, value));
    }
}

export const SetProgramIDs = (value) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(PatientSkillAcqActiveProgramListActionTypes.set_ProgramIds.SUCCESS, value));
    }
}

export const SetProgramIDsForSkillAcqTargetAction = (value) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(PatientSkillAcqActiveProgramListActionTypes.set_ProgramForSKillAxqTargetApplicationState.SUCCESS, value));
    }
}

export const resetProgramAndTarget = () => {
    return (dispatch, getState) => {
        dispatch(actionCreator(PatientSkillAcqActiveProgramListActionTypes.reset_ProgramAndtarget.SUCCESS, null));
    }
}


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Maintenance/components/programs/actions/programsActions.js